<script>
  // Presentational only. `letter` is a phonic-sound chunk (one letter or several,
  // e.g. sh / ne / igh). The font stays the same size for every sound; the tile
  // simply grows wider when the chunk has more letters.
  let { letter, index, active = false, played = false, hint = false, sel = false } = $props()
</script>

<div class="tile" class:active class:played class:hint class:sel data-index={index}>
  <span class="glyph">{letter}</span>
</div>

<style>
  .tile {
    display: flex;
    align-items: center;
    justify-content: center;
    width: auto;
    min-width: min(20vh, 22vw);
    max-width: 46vw;
    height: min(24vh, 26vw);
    max-height: 280px;
    padding: 0 2.4vh;
    box-sizing: border-box;
    border-radius: 22px;
    background: #fffef0;
    box-shadow: 0 10px 22px rgba(0, 0, 0, 0.18);
    transition: transform 120ms ease, background 120ms ease, box-shadow 120ms ease;
    user-select: none;
  }
  .glyph {
    font-size: min(15vh, 16vw);
    line-height: 1;
    font-weight: 800;
    color: #2e5d1f;
    pointer-events: none;
    white-space: nowrap;
  }
  .tile.played { background: #fff6d6; }
  .tile.hint { animation: wiggle 0.55s ease-in-out infinite; box-shadow: 0 10px 22px rgba(255, 140, 66, 0.45); }
  @keyframes wiggle {
    0%, 100% { transform: rotate(0deg); }
    25% { transform: rotate(-4deg); }
    75% { transform: rotate(4deg); }
  }
  .tile.active {
    transform: scale(1.13) translateY(-1vh);
    background: #ffd24d;
    box-shadow: 0 16px 32px rgba(255, 140, 66, 0.5);
  }
  .tile.active .glyph { color: #7a4a00; }
  .tile.sel { outline: 0.6vh solid #ff7043; outline-offset: 0.4vh; background: #fff3ec; }
</style>
